import {Entity} from '../base/entity';
import {isNil} from 'lodash';

export class Zaposleni extends Entity {

  public static readonly TABLENAME = 'zaposleni';

  public static readonly ID = 'id';
  public static readonly IME = 'ime';
  public static readonly SREDNJE_IME = 'srednje_ime';
  public static readonly PREZIME = 'prezime';
  public static readonly POL = 'pol';
  public static readonly ADDRESS = 'address';
  public static readonly CITY_ID = 'city_id';
  public static readonly JMBG = 'jmbg';
  public static readonly DATUM_RODJENJA = 'datum_rodjenja';
  public static readonly EMAIL = 'email';
  public static readonly USERNAME = 'username';
  public static readonly EVIDENCIONI_BROJ = 'evidencioni_broj';
  public static readonly NAPOMENA = 'napomena';
  public static readonly WORK_GROUP_ID = 'work_group_id';
  public static readonly ZANIMANJE_ID = 'zanimanje_id';


  id: number;
  ime: string;
  srednjeIme: string;
  prezime: string;
  pol: string;
  address: string;
  cityId: number;
  jmbg: string;
  datumRodjenja: Date | null;
  email: any;
  username: string;
  evidencioniBroj: string;
  napomena: string;
  workGroupId: number;
  zanimanjeId: number;

  workGroup: string;

  get fullName() {
    return (!isNil(this.prezime) ? `${this.prezime} ` : '') +
           (!isNil(this.srednjeIme) ? `${this.srednjeIme} ` : '') +
           (!isNil(this.ime) ? this.ime : '');
  }
}
